import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import PSMFeaturesData from '../../data/psm/PSMFeatures.json';
import SectionTitle from '../../elements/section-title/SectionTitle';

const PSMBestForYouSection = () => {
    return (
        <div className="section section-padding psm-best-for-you-section">
            <div className="container">
                <SectionTitle
                    subtitle="Our Process"
                    title="Best For You"
                    textAlignment="title heading-left mb--40"
                    textColor=""
                    paragraphClass="d-none"
                />
                <ul className="list-unstyled shape-group-10">
                    <li className="shape shape-1 shape-1-img-wrapper">
                        <img
                            src={process.env.PUBLIC_URL + "/images/others/line-9.png"}
                            alt="Circle"
                            className="shape-1-img"
                        />
                    </li>
                </ul>
                <div className="BFY-inner">
                    {/* Left Side - Pyramid Image */}
                    <div className="d-flex col-lg-6 col-md-12 mb-5 mb-lg-0">
                        <AnimationOnScroll animateIn="fadeInLeft" animateOnce={true}>
                            <div className="psm-image-wrapper">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/banner/PSM-best-for-you.png"}
                                    alt="Best For You Process"
                                    className="psm-pyramid-image"
                                />
                            </div>
                        </AnimationOnScroll>
                    </div>

                    {/* Right Side - Process Steps */}
                    <div className="col-lg-6 col-md-12">
                        <AnimationOnScroll animateIn="fadeInRight" animateOnce={true}>
                            <div className="">
                                {/* Process Steps */}
                                <div className="psm-steps-container">
                                    {PSMFeaturesData.map((feature, index) => (
                                        <div className="psm-step-item" key={index}>
                                            <div className="psm-step-number-wrapper">
                                                <div className="psm-step-number">{index + 1}</div>
                                                {index < PSMFeaturesData.length - 1 && (
                                                    <div className="psm-step-connector"></div>
                                                )}
                                            </div>
                                            <div className="psm-step-content">
                                                <h5 className="psm-step-title">{feature.title}</h5>
                                                <p className="psm-step-description">{feature.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </AnimationOnScroll>
                    </div>
                </div>
            </div>

            <style jsx>{`
 .shape-1-img {
     opacity: 0.2;
     max-width: 80%;
     float: inline-end;
}
 .shape-1-img-wrapper{
     top: 30px;
}
 .BFY-inner{
     display: flex;
     flex-direction: row;
     align-items: center;
}
 .psm-best-for-you-section {
     background-color: #ffffff;
     position: relative;
     overflow: hidden;
     padding: 0px 0 110px;
}
 .psm-image-wrapper {
     position: relative;
     width: 100%;
     max-width: 500px;
     margin: 0 auto;
}
 .psm-pyramid-image {
     width: 100%;
     height: auto;
     object-fit: contain;
}
 .psm-content-wrapper {
     position: relative;
}
 .psm-section-header {
     position: relative;
}
 .psm-subtitle {
     color: #FF6B6B;
     font-size: 16px;
     font-weight: 500;
     margin-bottom: 10px;
     text-transform: capitalize;
}
 .psm-title {
     color: #1a1a1a;
     font-size: 48px;
     font-weight: 700;
     line-height: 1.2;
     margin-bottom: 0;
}
 .psm-wave-line {
     position: absolute;
     top: 20px;
     right: 0;
     width: 350px;
     height: 50px;
     opacity: 0.6;
}
 .psm-steps-container {
     margin-top: 40px;
}
 .psm-step-item {
     display: flex;
     gap: 20px;
     margin-bottom: 35px;
     position: relative;
}
 .psm-step-item:last-child {
     margin-bottom: 0;
}
 .psm-step-number-wrapper {
     position: relative;
     flex-shrink: 0;
}
 .psm-step-number {
     width: 50px;
     height: 50px;
     border-radius: 50%;
     border: 2px solid #333;
     background-color: #fff;
     display: flex;
     align-items: center;
     justify-content: center;
     font-size: 20px;
     font-weight: 600;
     color: #333;
     z-index: 1;
     position: relative;
}
 .psm-step-connector {
     position: absolute;
     left: 50%;
     top: 55px;
     transform: translateX(-50%);
     width: 2px;
     height: 50px;
     background: linear-gradient(to bottom, #ddd 50%, transparent 50%);
     background-size: 2px 8px;
     z-index: 0;
}
 .psm-step-content {
     flex: 1;
     padding-top: 5px;
}
 .psm-step-title {
     color: #1a1a1a;
     font-size: 20px;
     font-weight: 600;
     margin-bottom: 8px;
     line-height: 1.3;
}
 .psm-step-description {
     color: #666;
     font-size: 15px;
     line-height: 1.6;
     margin-bottom: 0;
}
/* Responsive Styles */
 @media (max-width: 991px) {
     .psm-title {
         font-size: 36px;
    }
     .psm-wave-line {
         width: 250px;
    }
     .shape-1-img {
         max-width: 40%;
    }
     .BFY-inner{
         flex-direction: column-reverse;
    }
     .psm-best-for-you-section {
         padding: 60px 0 30px;
    }
     .psm-steps-container {
         margin-top: 0px;
         margin-bottom: 40px;
    }
}
 @media (max-width: 767px) {
     .psm-title {
         font-size: 32px;
    }
     .psm-wave-line {
         display: none;
    }
     .psm-step-number {
         width: 45px;
         height: 45px;
         font-size: 18px;
    }
     .psm-step-title {
         font-size: 18px;
    }
     .psm-step-description {
         font-size: 14px;
    }
}
 @media (max-width: 575px) {
     .psm-title {
         font-size: 28px;
    }
     .psm-step-item {
         gap: 15px;
         margin-bottom: 30px;
    }
}

            `}</style>
        </div>
    );
};

export default PSMBestForYouSection;